var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBee(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 59 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.877 34.015c.755.593 1.837.474 2.417-.267.579-.74.436-1.822-.32-2.415-.755-.594-1.837-.475-2.416.266-.58.74-.437 1.822.319 2.416z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.961 51.596c-.239.305-.486.599-.736.888l1.426-1.812c-.223.31-.45.62-.69.925zM33.737 10.525a26.032 26.032 0 0110.458 2.701L13.67 52.1a25.946 25.946 0 01-5.12-9.497l25.187-32.078zM57.414 29.08L32.176 61.22a26.027 26.027 0 01-10.44-2.723l30.54-38.896a25.96 25.96 0 015.138 9.477z",
    fill: "#F6C710"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.312 22.477c.496-.81 1.038-1.6 1.638-2.365a25.11 25.11 0 011.907-2.153c5.09-5.136 12.037-7.653 19.008-7.348L8.703 42.672c-1.96-6.69-1.17-14.031 2.609-20.195zM48.588 16.011a26.52 26.52 0 013.83 3.674L21.884 58.577a26.481 26.481 0 01-8.355-6.56l30.519-38.871a26.56 26.56 0 014.54 2.865zM53.72 50.716l-1.418 1.807c-5.178 6.01-12.708 8.963-20.255 8.612L57.26 29.008c2.142 7.24 1.066 15.25-3.54 21.708z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.613 18.595c2.501 1.366 5.596.473 6.912-1.992 1.315-2.466.354-5.57-2.148-6.935-2.501-1.365-5.596-.473-6.912 1.993-1.315 2.465-.354 5.57 2.148 6.934z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.26 28.502c7.69-.874 13.079-7.815 12.037-15.502C57.255 5.312 50.176-.21 42.486.663 28.562 2.245 14.82 17.94 14.82 17.94s17.516 12.143 31.44 10.561z",
    fill: "#E5E5E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.972 13.09a.973.973 0 001.36-.228.984.984 0 00-.257-1.362.973.973 0 00-1.36.228.984.984 0 00.257 1.361z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.158 22.936c1.919 2.11 1.792 5.334-.283 7.202-2.075 1.869-5.313 1.673-7.232-.436-1.919-2.11-1.792-5.335.283-7.203 2.075-1.869 5.312-1.673 7.232.437z",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.042 50.464c.99 7.718-4.467 14.639-12.187 15.46-7.721.821-14.782-4.769-15.773-12.486C-.71 39.465 11.26 22.295 11.26 22.295S27.25 36.49 29.042 50.465z",
    fill: "#E5E5E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.673 23.62c.41.36.456.978.104 1.38a.98.98 0 01-1.38.073.979.979 0 01-.105-1.378.978.978 0 011.381-.074z",
    fill: "#fff"
  })));
}

export default SvgBee;